<template>
    <section>
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark ">
            <a class="navbar-brand p-3" href="#"><img src="/images/logo.svg"><p class="logo-titulo">Parroquia del Espíritu Santo</p></a>
        </nav>
        <div class="row p-4">
            <div class="col-12 text-center">
               <h1>La página que buscas no existe</h1>
            </div>
        </div>
    </section>
</template>


